import { useId } from 'react';

export function Brand({ compact = false }: { compact?: boolean }) {
  const gradientId = useId().replace(/:/g, '');

  return (
    <div className="brand" aria-label="Plessage">
      <svg className="brand-mark" viewBox="0 0 40 40" aria-hidden="true">
        <defs>
          <linearGradient id={gradientId} x1="7" y1="4" x2="34" y2="36" gradientUnits="userSpaceOnUse">
            <stop stopColor="#06B6D4" />
            <stop offset="1" stopColor="#2563EB" />
          </linearGradient>
        </defs>
        <path fill={`url(#${gradientId})`} d="M8 6.5A3.5 3.5 0 0 1 11.5 3h10.8C31 3 37 8.5 37 16.4c0 8-6 13.2-14.7 13.2h-5.4v5.9A3.5 3.5 0 0 1 13.4 39H8V6.5Zm8.9 5v10.7h5.2c4.4 0 6.8-2 6.8-5.5s-2.4-5.2-6.8-5.2h-5.2Z" />
      </svg>
      {!compact && <span><strong>lessage</strong></span>}
    </div>
  );
}
